/**
 * Pro Carousel — shared drag + inertia + scrollbar thumb logic.
 * Auto-initialises every section that contains a .pro-carousel element.
 */
(function(){
  'use strict';

  function initCarousel(section){
    if(!section || section.dataset.proDragInit === '1') return;

    var containers = section.querySelectorAll('.container');
    var container  = containers && containers.length ? containers[0] : null;
    var track      = section.querySelector('.pro-carousel__track');
    var thumb      = section.querySelector('.pro-carousel__thumb');

    if(!container || !track || !thumb) return;

    section.dataset.proDragInit = '1';

    /* === offsets based on container === */
    function setOffsets(){
      var rect = container.getBoundingClientRect();
      var left = Math.max(0, rect.left);

      if(window.innerWidth >= 768){
        section.style.setProperty('--pro-left', left + 'px');
        section.style.setProperty('--pro-right', left + 'px');
      } else {
        section.style.removeProperty('--pro-left');
        section.style.removeProperty('--pro-right');
      }
    }

    /* === thumb === */
    function updateThumb(){
      var sw = track.scrollWidth;
      var cw = track.clientWidth;
      var sl = track.scrollLeft;

      var bar = thumb.parentElement;
      var bw  = bar.clientWidth;

      if(sw <= cw){
        thumb.style.width = bw + 'px';
        thumb.style.left  = '0px';
        return;
      }

      var maxScroll = sw - cw;
      var tw = Math.round((cw / sw) * bw);
      if(tw < 30) tw = 30;
      if(tw > bw) tw = bw;

      var maxLeft  = bw - tw;
      var progress = maxScroll > 0 ? (sl / maxScroll) : 0;
      var left     = Math.round(maxLeft * progress);

      thumb.style.width = tw + 'px';
      thumb.style.left  = left + 'px';
    }

    track.addEventListener('scroll', updateThumb, {passive:true});
    window.addEventListener('resize', function(){ setOffsets(); updateThumb(); });

    requestAnimationFrame(function(){ setOffsets(); updateThumb(); });

    track.addEventListener('dragstart', function(e){ e.preventDefault(); });

    /* === DRAG + INERTIA (desktop, pointer events) === */
    var isPointerDown  = false;
    var isDragging     = false;
    var startX         = 0;
    var startScrollLeft= 0;
    var DRAG_THRESHOLD = 6;
    var lastX = 0, lastT = 0, v = 0, raf = 0;

    function disableSelection(){ document.body.style.userSelect = 'none'; document.body.style.webkitUserSelect = 'none'; }
    function enableSelection(){  document.body.style.userSelect = '';     document.body.style.webkitUserSelect = ''; }

    function stopInertia(){ if(raf) cancelAnimationFrame(raf); raf = 0; }

    function startInertia(){
      stopInertia();
      if(Math.abs(v) < 0.05) return;
      var friction = 0.94, minV = 0.04;
      var step = function(){
        track.scrollLeft -= v * 16;
        v *= friction;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if(track.scrollLeft <= 0 || track.scrollLeft >= maxScroll) v = 0;
        if(Math.abs(v) < minV){ v = 0; raf = 0; return; }
        raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }

    track.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse') return;
      if(e.button !== 0) return;
      stopInertia();
      isPointerDown = true; isDragging = false;
      startX = e.clientX; startScrollLeft = track.scrollLeft;
      lastX = e.clientX; lastT = performance.now(); v = 0;
    }, true);

    track.addEventListener('pointermove', function(e){
      if(!isPointerDown) return;
      var dx = e.clientX - startX;
      if(!isDragging && Math.abs(dx) > DRAG_THRESHOLD){
        isDragging = true;
        disableSelection();
        track.style.cursor = 'grabbing';
        track.setPointerCapture(e.pointerId);
      }
      if(!isDragging) return;
      track.scrollTo({ left: startScrollLeft - dx, behavior: 'auto' });
      var now = performance.now(), dt = now - lastT;
      if(dt > 0){ var vx = (e.clientX - lastX) / dt; v = v * 0.75 + vx * 0.25; lastX = e.clientX; lastT = now; }
      e.preventDefault();
    }, {passive:false});

    function endPointer(){
      if(!isPointerDown) return;
      isPointerDown = false;
      enableSelection();
      track.style.cursor = 'grab';
      if(isDragging) startInertia();
      setTimeout(function(){ isDragging = false; }, 50);
    }

    track.addEventListener('pointerup', endPointer);
    track.addEventListener('pointercancel', endPointer);
    track.addEventListener('pointerleave', endPointer);

    track.addEventListener('click', function(e){
      if(isDragging){ e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* === Boot: find all pro-carousel sections and init === */
  function bootAll(){
    var sections = document.querySelectorAll('.pro-carousel-section');
    for(var i = 0; i < sections.length; i++){
      initCarousel(sections[i]);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootAll, {once:true});
  } else {
    bootAll();
  }

  /* Handle dynamically loaded content (recommendations, recently viewed) */
  var dynObserver = new MutationObserver(function(){
    var sections = document.querySelectorAll('.pro-carousel-section');
    for(var i = 0; i < sections.length; i++){
      if(sections[i].dataset.proDragInit !== '1'){
        initCarousel(sections[i]);
      }
    }
  });
  dynObserver.observe(document.body, {childList:true, subtree:true});
  setTimeout(function(){ dynObserver.disconnect(); }, 30000);

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function(e){
    var sec = e.target && e.target.querySelector ? e.target.closest('.pro-carousel-section') || e.target.querySelector('.pro-carousel-section') : null;
    if(sec){ sec.dataset.proDragInit = '0'; initCarousel(sec); }
  });
})();
